<c-container fluid class="m-0">
  <c-row>
    <c-col [cCol]="3">
      <i #iconEle [class]="info.icon"></i>
    </c-col>
    <c-col cCol>{{ info.title }}</c-col>
  </c-row>
</c-container>
